import axios from 'axios';
import { getConfig } from '../config';
import { AdminApiDomain, getAdminApiUrl } from '../config/ApiRouting';

export interface NotificationData {
  action: 'navigation';
  payload: {
    url: string;
  };
}

export interface SendPushNotificationToAllRequest {
  title: string;
  body: string;
  data: NotificationData;
}

export interface SendPushNotificationToAllResponse {
  success: boolean;
  message: string;
  totalDevices: number;
  successCount: number;
  failureCount: number;
  errors?: string[];
}

export interface SendPushNotificationRequest {
  receiver: {
    type: 'UserId' | 'Session';
    identifier: string;
  };
  title: string;
  body: string;
  data: NotificationData;
}

export interface SendPushNotificationResponse {
  success: boolean;
  message: string;
  receiptId?: string;
  error?: string;
}

export class PushNotificationClient {
  private readonly baseUrl: string;

  constructor() {
    this.baseUrl = getAdminApiUrl(AdminApiDomain.DEVICE);
  }

  async sendToAll(request: SendPushNotificationToAllRequest): Promise<SendPushNotificationToAllResponse> {
    const response = await axios.post<SendPushNotificationToAllResponse>(
      `${this.baseUrl}/device/pushNotificationToAll`,
      request,
      {
        headers: {
          'X-API-KEY': getConfig().apiKey,
        },
      },
    );
    return response.data;
  }

  async sendToUser(request: SendPushNotificationRequest): Promise<SendPushNotificationResponse> {
    const response = await axios.post<SendPushNotificationResponse>(
      `${this.baseUrl}/device/sendPushNotification`,
      request,
      {
        headers: {
          'X-API-KEY': getConfig().apiKey,
        },
      },
    );
    return response.data;
  }
}
